import React from 'react';
import Header from './Header';

const Layout = ({ children }) => {
    return (
        <div className="min-h-screen bg-background text-white font-sans">
            <Header />
            <main className="p-4 md:p-8 pt-20">
                {children}
            </main>
        </div>
    );
};

export default Layout;
